import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Icon,
  Form,
  FormGroup,
  FormField,
  Label,
  Button
} from 'semantic-ui-react'

const CardMeLabReportUX = (props: any) => {
    return(
      <div
        id="CardLabReportUX-div-0"
        style={{padding:"10px", minWidth: "max-content", height: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column", overflow: "hidden"}}>
        <div
          id="CardLabReportUX-div-15"
          style={{ paddingBottom: "10px", flexShrink: 0 }}>
          
          <div
            id="CardLabReportUX-div-17"
            style={{ paddingBottom: "10px" }}>
            
            <div
              id="CardLabReportUX-div-19"
              style={{ fontSize: "1.2rem", fontWeight: "bold", padding:"0.35rem 0 0.35rem", display: "flex", justifyContent: "space-between"}}>
              
              <div
                id="CardLabReportUX-div-82">
                {props.titleName || "Lab Results"}
              </div>
              <div
                id="CardLabReportUX-div-83">
                
                <Icon
                  className="red"
                  id="CardLabReportUX-Icon-84"
                  link={true}
                  name="close"
                  onClick={props.onClose}>
                </Icon>
              </div>
            </div>
            <hr
              id="CardLabReportUX-hr-20">
            </hr>
          </div>
          <div
            id="CardMeLabReportUX-div-97">
            
            <div
              id="CardMeLabReportUX-div-98">
              
              <Form
                id="CardMeLabReportUX-Form-99">
                <FormGroup
                  id="CardMeLabReportUX-FormGroup-100"
                  style={{display:"flex",  paddingBottom: "1rem" }}>
                  <FormField
                    id="CardMeLabReportUX-FormField-101"
                    width={2}>
                    <label
                      id="CardMeLabReportUX-label-110">
                      ชื่อ - นามสกุล
                    </label>
                    <Label
                      id="CardMeLabReportUX-Label-115"
                      style={{ width: "100%", padding: "0.5rem 1.5rem", background: "#FFE5E5" }}>
                      {props.patientInfo?.full_name || "\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardMeLabReportUX-FormField-140"
                    width={2}>
                    <label
                      id="CardMeLabReportUX-label-143">
                      วันเกิด
                    </label>
                    <Label
                      id="CardMeLabReportUX-Label-145"
                      style={{ width: "100%", padding: "0.5rem 1.5rem", background: "#FFE5E5" }}>
                      {props.birthdate || props.patientInfo?.birthdate}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardMeLabReportUX-FormField-141"
                    width={2}>
                    <label
                      id="CardMeLabReportUX-label-142">
                      อายุ
                    </label>
                    <Label
                      id="CardMeLabReportUX-Label-144"
                      style={{ width: "100%", padding: "0.5rem 1.5rem", background: "#FFE5E5" }}>
                      {props.patientInfo?.full_age}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardMeLabReportUX-FormField-102"
                    width={2}>
                    <label
                      id="CardMeLabReportUX-label-109">
                      LabID
                    </label>
                    <Label
                      id="CardMeLabReportUX-Label-114"
                      style={{ width: "100%", padding: "0.5rem 1.5rem", background: "#FFE5E5" }}>
                      {props.selectedLabOrderWorking?.full_access_number || "\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardMeLabReportUX-FormField-103"
                    width={2}>
                    <label
                      id="CardMeLabReportUX-label-108">
                      Lab Center
                    </label>
                    <Label
                      id="CardMeLabReportUX-Label-113"
                      style={{ width: "100%", padding: "0.5rem 1.5rem", background: "#FFE5E5" }}>
                      {"\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardMeLabReportUX-FormField-104"
                    width={2}>
                    <label
                      id="CardMeLabReportUX-label-107">
                      วันเวลาที่ส่งLab Center
                    </label>
                    <Label
                      id="CardMeLabReportUX-Label-112"
                      style={{ width: "100%", padding: "0.5rem 1.5rem", background: "#FFE5E5" }}>
                      {"\u00a0"}
                    </Label>
                  </FormField>
                  <FormField
                    id="CardMeLabReportUX-FormField-105"
                    width={2}>
                    <label
                      id="CardMeLabReportUX-label-106">
                      สถานะ
                    </label>
                    <Label
                      id="CardMeLabReportUX-Label-111"
                      style={{ width: "100%", padding: "0.5rem 1.5rem", background: "#FFE5E5" }}>
                      {props.selectedLabOrderWorking?.status_name || "\u00a0"}
                    </Label>
                  </FormField>
                </FormGroup>
              </Form>
            </div>
          </div>
        </div>
        <div
          id="CardMeLabReportUX-div-117"
          style={{ display: "flex", alignItems: "flex-start", flexShrink: 0 }}>
          {}
          <div
            id="CardMeLabReportUX-div-118">
            
            <Button
              color="blue"
              disabled={props.disabledAttachFile || false}
              id="CardMeLabReportUX-Button-126"
              loading={props.loadingPrint}
              onClick={props.onAttachFile}>
              {props.languageUX === "en" ? "Attach file" : "แนบไฟล์"}
            </Button>
          </div>
          <div
            id="CardMeLabReportUX-div-119">
            
            <div
              id="CardMeLabReportUX-div-133">
              {props.buttonPrintLabResult}
            </div>
          </div>
          <div
            id="CardMeLabReportUX-div-120"
            style={{ margin: "0px 3.5px" }}>
            
            <div
              id="CardMeLabReportUX-div-138"
              style={{ width: "10rem" }}>
              {props.buttonOCRScanner}
            </div>
          </div>
          <div
            id="CardMeLabReportUX-div-147"
            style={{ margin: "0px 3.5px" }}>
            
            <Button
              id="CardMeLabReportUX-Button-148"
              onClick={props.onOpenEditRemark}
              style={{ background: "#6D3FD6", color: "#FFF", position: "relative" }}>
              {props.labelButtonRemark || "Remark"}
            </Button>
          </div>
          <div
            id="CardMeLabReportUX-div-121">
            
            <Button
              disabled={props.disabledLabReport || false}
              id="CardMeLabReportUX-Button-128"
              onClick={props.onLabReport}
              style={{display: props.hideButtonLabReport ? "none":""}}>
              {props.languageUX === "en" ? "Lab Report" : "รายงานการทดลอง"}
            </Button>
          </div>
          <div
            id="CardMeLabReportUX-div-122"
            style={{ flex: 1 }}>
            
          </div>
          <div
            id="CardMeLabReportUX-div-123"
            style={{marginRight:"5px"}}>
            
            <div
              id="CardMeLabReportUX-div-135">
              {props.inputPassword}
            </div>
          </div>
          <div
            id="CardMeLabReportUX-div-124"
            style={{marginRight:"5px"}}>
            
            <div
              id="CardMeLabReportUX-div-132">
              {props.buttonSave}
            </div>
          </div>
          <div
            id="CardMeLabReportUX-div-125"
            style={{marginRight:"5px"}}>
            
            <div
              id="CardMeLabReportUX-div-131">
              {props.buttonAuthorize}
            </div>
          </div>
          <div
            id="CardMeLabReportUX-div-139"
            style={{marginRight:"5px"}}>
            {props.buttonGenVideo}
          </div>
        </div>
        <div
          id="CardMeLabReportUX-div-146"
          style={{ color: "rgba(117, 117, 117, 0.5)", fontSize: "12px", marginTop: "3px", flexShrink: 0 }}>
          Support: JPG, PNG, PDF (Image-based documents)
        </div>
        <div
          id="CardMeLabReportUX-div-162"
          style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
          
          <div
            id="CardMeLabReportUX-div-149"
            style={{   margin: "6px 0px 14px",   background: "#F6F2FF",   border: "1px solid #D9CDFB",   borderRadius: "8px",   padding: "14px 16px", flexShrink: 0, ...(!props.openEditRemark && { display: "none" }) }}>
            
            <div
              id="CardMeLabReportUX-div-150">
              
              <label
                id="CardMeLabReportUX-label-155"
                style={{   fontWeight: "bold",   color: "#5B3FB0",   marginBottom: "4px",   fontSize: "14px", }}>
                Remark ผลแลปรวม
              </label>
            </div>
            <div
              id="CardMeLabReportUX-div-151">
              
              <div
                id="CardMeLabReportUX-div-156"
                style={{ color: "#8A7AB0", fontSize: "12px", margin: "8px 0px" }}>
                * กำหนดความยาวไม่เกิน 2 บรรทัดของกระดาษ A4 (ไม่เกิน 200 ตัวอักษร)
              </div>
            </div>
            <div
              id="CardMeLabReportUX-div-152">
              
              <div
                id="CardMeLabReportUX-div-158">
                {props.textareaRemark}
              </div>
            </div>
            <div
              id="CardMeLabReportUX-div-153">
              
              <div
                id="CardMeLabReportUX-div-157"
                style={{   textAlign: "right",   color: "#A99BD6",   fontSize: "11.5px",   margin: "10px 0px", }}>
                {`${props.remarkLength || 0} / ${props.maxRemarkLength || 0}`}
              </div>
            </div>
            <div
              id="CardMeLabReportUX-div-154"
              style={{ display: "flex", justifyContent: "flex-end" }}>
              
              <Button
                id="CardMeLabReportUX-Button-159"
                onClick={props.onCloseEditRemark}
                style={{   background: "#E5E0F2",   color: "#5B3FB0", }}>
                ยกเลิก
              </Button>
              <div
                id="CardMeLabReportUX-div-161">
                {props.buttonSaveRemark}
              </div>
            </div>
          </div>
          <div
            id="CardMeLabReportUX-div-163"
            style={{ flexShrink: 0, ...(!props.showRemarkBanner && { display: "none" }) }}>
            {props.remarkBanner}
          </div>
          <div
            id="CardLabReportUX-div-59"
            style={{marginTop:"10px", flex: 1, minHeight: 0, overflow: "hidden"}}>
            {props.tableReport}
          </div>
        </div>
      </div>
    )
}


export default CardMeLabReportUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Fri Sep 04 2026 09:50:14 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"10px\", minWidth: \"max-content\", height: \"100%\", boxSizing: \"border-box\", display: \"flex\", flexDirection: \"column\", overflow: \"hidden\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"10px\", flexShrink: 0 }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"10px\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\", padding:\"0.35rem 0 0.35rem\", display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "hr",
      "parent": 17,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-hr-20"
        }
      },
      "seq": 20,
      "void": true
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "props.titleName || \"Lab Results\""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-83"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Icon",
      "parent": 83,
      "props": {
        "className": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-Icon-84"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-97"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Form",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Form-99"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormGroup",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-FormGroup-100"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",  paddingBottom: \"1rem\" }"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-FormField-101"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-FormField-102"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-FormField-103"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-FormField-104"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-FormField-105"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-label-106"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเวลาที่ส่งLab Center"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-label-107"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "Lab Center"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-label-108"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "LabID"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-label-109"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "label",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - นามสกุล"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-label-110"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Label",
      "parent": 105,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.status_name || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Label-111"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0.5rem 1.5rem\", background: \"#FFE5E5\" }"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Label",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Label-112"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0.5rem 1.5rem\", background: \"#FFE5E5\" }"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Label",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Label-113"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0.5rem 1.5rem\", background: \"#FFE5E5\" }"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Label",
      "parent": 102,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.full_access_number || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Label-114"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0.5rem 1.5rem\", background: \"#FFE5E5\" }"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Label",
      "parent": 101,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo?.full_name || \"\\u00a0\""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Label-115"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0.5rem 1.5rem\", background: \"#FFE5E5\" }"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-117"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"flex-start\", flexShrink: 0 }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-118"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-119"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 3.5px\" }"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-121"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-123"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-124"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-125"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "Button",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "แนบไฟล์",
          "valueEN": "Attach file"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAttachFile || false"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Button-126"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPrint"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAttachFile"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "Button",
      "parent": 121,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานการทดลอง",
          "valueEN": "Lab Report"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledLabReport || false"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Button-128"
        },
        "onClick": {
          "type": "code",
          "value": "props.onLabReport"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideButtonLabReport ? \"none\":\"\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 125,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAuthorize"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-131"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-132"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintLabResult"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-133"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 123,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inputPassword"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-135"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 120,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonOCRScanner"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-138"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"10rem\" }"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonGenVideo"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-FormField-140"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-FormField-141"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "label",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุ"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-label-142"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "label",
      "parent": 140,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเกิด"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-label-143"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Label",
      "parent": 141,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo?.full_age"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Label-144"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0.5rem 1.5rem\", background: \"#FFE5E5\" }"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Label",
      "parent": 140,
      "props": {
        "children": {
          "type": "code",
          "value": "props.birthdate || props.patientInfo?.birthdate"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Label-145"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0.5rem 1.5rem\", background: \"#FFE5E5\" }"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "Support: JPG, PNG, PDF (Image-based documents)"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"rgba(117, 117, 117, 0.5)\", fontSize: \"12px\", marginTop: \"3px\", flexShrink: 0 }"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-147"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 3.5px\" }"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "Button",
      "parent": 147,
      "props": {
        "children": {
          "type": "code",
          "value": "props.labelButtonRemark || \"Remark\""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Button-148"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenEditRemark"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#6D3FD6\", color: \"#FFF\", position: \"relative\" }"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-162"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flexDirection: \"column\", flex: 1, minHeight: 0 }"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 162,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{   margin: \"6px 0px 14px\",   background: \"#F6F2FF\",   border: \"1px solid #D9CDFB\",   borderRadius: \"8px\",   padding: \"14px 16px\", flexShrink: 0, ...(!props.openEditRemark && { display: \"none\" }) }"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-150"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "label",
      "parent": 164,
      "props": {
        "children": {
          "type": "value",
          "value": "Remark ผลแลปรวม"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-label-155"
        },
        "style": {
          "type": "code",
          "value": "{   fontWeight: \"bold\",   color: \"#5B3FB0\",   marginBottom: \"4px\",   fontSize: \"14px\", }"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-151"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "value",
          "value": "* กำหนดความยาวไม่เกิน 2 บรรทัดของกระดาษ A4 (ไม่เกิน 200 ตัวอักษร)"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"#8A7AB0\", fontSize: \"12px\", margin: \"8px 0px\" }"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-152"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 168,
      "props": {
        "children": {
          "type": "code",
          "value": "props.textareaRemark"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-158"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-153"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 170,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.remarkLength || 0} / ${props.maxRemarkLength || 0}`"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-157"
        },
        "style": {
          "type": "code",
          "value": "{   textAlign: \"right\",   color: \"#A99BD6\",   fontSize: \"11.5px\",   margin: \"10px 0px\", }"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "Button",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-Button-159"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseEditRemark"
        },
        "style": {
          "type": "code",
          "value": "{   background: \"#E5E0F2\",   color: \"#5B3FB0\", }"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSaveRemark"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-161"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 162,
      "props": {
        "children": {
          "type": "code",
          "value": "props.remarkBanner"
        },
        "id": {
          "type": "value",
          "value": "CardMeLabReportUX-div-163"
        },
        "style": {
          "type": "code",
          "value": "{ flexShrink: 0, ...(!props.showRemarkBanner && { display: \"none\" }) }"
        }
      },
      "seq": 174.5,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 162,
      "props": {
        "children": {
          "type": "code",
          "value": "props.tableReport"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"10px\", flex: 1, minHeight: 0, overflow: \"hidden\"}"
        }
      },
      "seq": 175,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 55,
  "isMounted": false,
  "memo": false,
  "name": "CardMeLabReportUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 85
}

*********************************************************************************** */
